import axios from "axios";
import { config } from "common/utils/constants";

const API_URL = config.url.API_URL;

function getQuizContent(id: Number): Promise<Object> {
  const response = axios
    .get(`${API_URL}/get-quiz?id=${id}`, {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    })
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      const errorMessage = err.message;
      throw new Error(errorMessage);
    });
  return response;
}

function postAnswers(answers: Object): Promise<Object> {
  const response = axios
    .post(`${API_URL}/save-quiz`, answers, {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    })
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      throw err.response;
    });
  return response;
}

export { getQuizContent, postAnswers };
